import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './AppRouter';
import './css/index.css';
import { authContext } from './AzureAd';
import 'bootstrap/dist/css/bootstrap.min.css';

// Prevent accidental value changes when scrolling over number inputs
document.addEventListener('wheel', (e) => {
  if (document.activeElement && document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
}, { passive: false });

console.log('check current cached user');
let user = authContext.getCachedUser();
let requireLogin = true;

if (user) {
  console.log("authenticated user: ", user);

  // let iat = user.profile.iat; //token建立時間
  let exp = user.profile.exp; //token到期時間 
  let now = Math.floor(Date.now() / 1000);
  // console.log("iat: ", iat);
  // console.log("exp: ", exp);
  // console.log("now: ", now);
  // console.log("dif: ", exp - now);
  if (exp - now < 180) {  //到期3分鐘前重新產生token
    console.log("token expired!");
    authContext.logOut();
    requireLogin = true;
  } else {
    requireLogin = false;
  }
}

console.log("requireLogin: ", requireLogin);
if (requireLogin) {
  authContext.login();
} else {
  ReactDOM.render(
    <AppRouter />,
    document.getElementById('root')
  );
}



// WEBPACK FOOTER //
// ./src/index.js